import { Link } from "react-router-dom";
import logo from "../../../res/logo.png";

function Publisher() {
  return (
    <section id="publisher" className="bg-sky-100 py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="lg:order-2">
            <img
              className="w-full max-w-md mx-auto rounded-lg"
              src={logo}
              alt="Philippine Engineering and Agro-Industrial College, Inc. Logo"
            />
          </div>
          <div className="lg:order-1 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 tracking-tight">
              The Publisher
            </h2>
            <p className="mt-6 text-xl font-semibold text-slate-800">
              The AJORIST is published by the Philippine Engineering and
              Agro-Industrial College, Inc.
            </p>
            <p className="mt-2 text-base text-slate-600">
              PEACI is a private, non-stock, non-profit educational institution
              founded in 2007 by a group of Meranao engineers.
            </p>
            <Link to="/" className="mt-4 inline-block text-sky-700 hover:text-sky-900 font-semibold underline">
              Visit Website
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Publisher;
